import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _copySeatingPlanRequest = {};
var _copySeatingPlanResponse = { plan: '_seatingPlan' };
var _createSeatingPlanRequest = { plan: '_seatingPlan' };
var _createSeatingPlanResponse = { plan: '_seatingPlan' };
var _deleteSeatingPlanRequest = {};
var _deleteSeatingPlanResponse = { plan: '_seatingPlan' };
var _describeCategoriesRequest = {};
var _describeCategoriesResponse = {};
var _describeSeatingPlanRequest = {};
var _describeSeatingPlanResponse = { plan: '_seatingPlan' };
var _findSeatingPlanRequest = {};
var _findSeatingPlanResponse = { plan: '_seatingPlan' };
var _getSeatingPlanRequest = {};
var _getSeatingPlanResponse = { plan: '_seatingPlan' };
var _querySeatingPlanRequest = {};
var _querySeatingPlanResponse = { plans: '_seatingPlan' };
var _querySeatingPlanVersionsRequest = {};
var _querySeatingPlanVersionsResponse = { plans: '_seatingPlan' };
var _saveSeatingPlanVersionRequest = { plan: '_seatingPlan' };
var _saveSeatingPlanVersionResponse = { plan: '_seatingPlan' };
var _seatingPlan = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _updateSeatingPlanRequest = {
    fields: 'google.protobuf.FieldMask',
    plan: '_seatingPlan',
};
var _updateSeatingPlanResponse = { plan: '_seatingPlan' };
function resolveComWixpressSeatingSeatingPlanManagementUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/seating-plans',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/seating-plans',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/seating-plans',
                destPath: '',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/seating-plans',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/seating-plans',
                destPath: '',
            },
        ],
        _api_base_domain_: [
            {
                srcPath: '/seating-plans',
                destPath: '',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/seating-plans',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/seating-plans',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressSeatingSeatingPublicServiceUrl(opts) {
    var domainToMappings = {
        _api_base_domain_: [
            {
                srcPath: '/seating-public',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/seating-public',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/seating-public',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/seating-public',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressSeatingSeatingPlanVersionManagementUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/seating-plans',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/seating-plans',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/seating-plans',
                destPath: '',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/seating-plans',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/seating-plans',
                destPath: '',
            },
        ],
        _api_base_domain_: [
            {
                srcPath: '/seating-plans',
                destPath: '',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/seating-plans',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/seating-plans',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Saves seating plan version
 * Increments SeatingPlan.version by 1 on every save.
 */
export function saveSeatingPlanVersion(payload) {
    return function __saveSeatingPlanVersion(_a) {
        var host = _a.host;
        var toJSON = serializer(_saveSeatingPlanVersionRequest, {
            _seatingPlan: _seatingPlan,
        }).toJSON;
        var fromJSON = serializer(_saveSeatingPlanVersionResponse, {
            _seatingPlan: _seatingPlan,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveComWixpressSeatingSeatingPlanVersionManagementUrl({
                protoPath: '/v1/plan-versions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Lists seating plan versions by provided query request */
export function querySeatingPlanVersions(payload) {
    return function __querySeatingPlanVersions(_a) {
        var host = _a.host;
        var toJSON = serializer(_querySeatingPlanVersionsRequest, {}).toJSON;
        var fromJSON = serializer(_querySeatingPlanVersionsResponse, {
            _seatingPlan: _seatingPlan,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveComWixpressSeatingSeatingPlanVersionManagementUrl({
                protoPath: '/v1/plan-versions/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Returns a seating plan with seat reservation status */
export function describeSeatingPlan(payload) {
    return function __describeSeatingPlan(_a) {
        var host = _a.host;
        var toJSON = serializer(_describeSeatingPlanRequest, {}).toJSON;
        var fromJSON = serializer(_describeSeatingPlanResponse, {
            _seatingPlan: _seatingPlan,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveComWixpressSeatingSeatingPublicServiceUrl({
                protoPath: '/v1/describe',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Returns available seat counts aggregated by category id */
export function describeCategories(payload) {
    return function __describeCategories(_a) {
        var host = _a.host;
        var toJSON = serializer(_describeCategoriesRequest, {}).toJSON;
        var fromJSON = serializer(_describeCategoriesResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveComWixpressSeatingSeatingPublicServiceUrl({
                protoPath: '/v1/describe-categories',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Crates a seating plan */
export function createSeatingPlan(payload) {
    return function __createSeatingPlan(_a) {
        var host = _a.host;
        var toJSON = serializer(_createSeatingPlanRequest, { _seatingPlan: _seatingPlan }).toJSON;
        var fromJSON = serializer(_createSeatingPlanResponse, {
            _seatingPlan: _seatingPlan,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveComWixpressSeatingSeatingPlanManagementUrl({
                protoPath: '/v1/plans',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Updates the seating plan */
export function updateSeatingPlan(payload) {
    return function __updateSeatingPlan(_a) {
        var host = _a.host;
        var toJSON = serializer(_updateSeatingPlanRequest, { _seatingPlan: _seatingPlan }).toJSON;
        var fromJSON = serializer(_updateSeatingPlanResponse, {
            _seatingPlan: _seatingPlan,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'PUT',
            url: resolveComWixpressSeatingSeatingPlanManagementUrl({
                protoPath: '/v1/plans',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Copies the seating plan */
export function copySeatingPlan(payload) {
    return function __copySeatingPlan(_a) {
        var host = _a.host;
        var toJSON = serializer(_copySeatingPlanRequest, {}).toJSON;
        var fromJSON = serializer(_copySeatingPlanResponse, { _seatingPlan: _seatingPlan }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveComWixpressSeatingSeatingPlanManagementUrl({
                protoPath: '/v1/plans/copy',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Lists seating plans by provided query request */
export function querySeatingPlan(payload) {
    return function __querySeatingPlan(_a) {
        var host = _a.host;
        var toJSON = serializer(_querySeatingPlanRequest, {}).toJSON;
        var fromJSON = serializer(_querySeatingPlanResponse, {
            _seatingPlan: _seatingPlan,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveComWixpressSeatingSeatingPlanManagementUrl({
                protoPath: '/v1/plans/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Returns the seating plan. Fails of not fond. */
export function getSeatingPlan(payload) {
    return function __getSeatingPlan(_a) {
        var host = _a.host;
        var toJSON = serializer(_getSeatingPlanRequest, {}).toJSON;
        var fromJSON = serializer(_getSeatingPlanResponse, { _seatingPlan: _seatingPlan }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveComWixpressSeatingSeatingPlanManagementUrl({
                protoPath: '/v1/plans/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Returns the first seating plan found by filter request. */
export function findSeatingPlan(payload) {
    return function __findSeatingPlan(_a) {
        var host = _a.host;
        var toJSON = serializer(_findSeatingPlanRequest, {}).toJSON;
        var fromJSON = serializer(_findSeatingPlanResponse, { _seatingPlan: _seatingPlan }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveComWixpressSeatingSeatingPlanManagementUrl({
                protoPath: '/v1/plans/find',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Deletes the seating plan. */
export function deleteSeatingPlan(payload) {
    return function __deleteSeatingPlan(_a) {
        var host = _a.host;
        var toJSON = serializer(_deleteSeatingPlanRequest, {}).toJSON;
        var fromJSON = serializer(_deleteSeatingPlanResponse, {
            _seatingPlan: _seatingPlan,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'DELETE',
            url: resolveComWixpressSeatingSeatingPlanManagementUrl({
                protoPath: '/v1/plans/{id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
//# sourceMappingURL=http.js.map